import postCheckUserTaxNumber from 'store/user/services/postCheckUserTaxNumber.service';

// Shared by the two places an avatar is created — AddUserDialog and the
// project invite — so both judge a tax number the way the backend does.

// A Finnish personal tax number is 12 digits starting with 1000 (mirrors
// regexPatterns.taxNumber in scenes/Filings/utils/constants.js).
export const TAX_NUMBER_REGEX = /^1000\d{8}$/;

// Vero's answer counts only when the number exists AND matches the birth date
// — the same test create-or-update-user applies before creating a phoneless
// avatar.
export const isVeroMatch = (result) =>
  result?.InfoExists === true && result?.TaxNumberMatchBirthday === true;

// Resolves true or false for a well-formed number; rejects when Vero could not
// be asked, which is not the same as the number being wrong.
export const checkTaxNumberWithVero = async (taxNumber, dateOfBirth) =>
  isVeroMatch(await postCheckUserTaxNumber(taxNumber, dateOfBirth));

// The backend wants first and last name apart; a single typed name splits on
// its last space, so "Anna Maria Virtanen" keeps both given names.
export const splitName = (name) => {
  const trimmed = String(name || '').trim();
  const lastSpace = trimmed.lastIndexOf(' ');
  if (lastSpace === -1) {
    return { firstName: trimmed, lastName: '' };
  }
  return {
    firstName: trimmed.slice(0, lastSpace).trim(),
    lastName: trimmed.slice(lastSpace + 1),
  };
};
